import PlainDate from '@Domain/PlainDate';
import resolvePeriodPresets from '@UI/Pages/Administration/AiCosts/Filters/Helpers/resolvePeriodPresets';
import aiCostsFiltersSignal, {
	setAiCostsFilters,
} from '@UI/Pages/Administration/AiCosts/Filters/Signals/aiCostsFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { SelectButton } from '@verclam/ui-kit';

/** Shortcut chips; none is pressed when the chosen period matches no shortcut. */
const PeriodPresets: React.FC = () => {
	const filters = useSignalValue(aiCostsFiltersSignal);
	const presets = React.useMemo(() => resolvePeriodPresets(PlainDate.today()), []);
	const currentKey =
		presets.find(
			(preset) =>
				preset.from.toApi() === filters.from.toApi() && preset.to.toApi() === filters.to.toApi(),
		)?.key ?? null;

	const handleChange = React.useCallback(
		(value: string | readonly string[] | null) => {
			const preset = presets.find((candidate) => candidate.key === value);

			if (preset === undefined) {
				return;
			}

			setAiCostsFilters(aiCostsFiltersSignal.peek().setPeriod(preset.from, preset.to));
		},
		[presets],
	);

	return (
		<SelectButton
			name="aiCostsPeriodPresets"
			label="Période"
			options={presets}
			optionLabel="label"
			optionValue="key"
			value={currentKey}
			onChange={handleChange}
			allowEmpty={false}
			size="sm"
		/>
	);
};

export default PeriodPresets;
